import { t } from '@lingui/core/macro';
import { useSearchContext } from '../../../SearchProvider';
export const useTeams = (teamIds) => {
    const { values } = useSearchContext();
    const { teams } = values;
    const fallbackTeam = {
        id: '',
        name: t({ message: 'Deleted team', comment: 'Fallback name for deleted team' }),
    };
    const teamsData = teamIds.map((tid) => teams.get(tid) || fallbackTeam);
    return teamsData;
};
